export const environment = {
  production: true,
  stripeKey:
    'pk_live_51OYTZmADdj7oaBaoEs7fvYV6cQuAsjbxmRrm68zVmZcMHHB38MLQOg5KXHDD3GamPbKTMQcaomJkMRhl8GKwemSv00ReedbpNE',
  server: 'https://server.esn.world',
  useApiPath: true,
  useLocalAuthMock: false,
  version: 'main',
};
